import React, { Fragment, useContext, useEffect, useState } from "react";
import AllReviews from "./AllReviews";
import ReviewForm from "./ReviewForm";
import { ProductDetailsContext } from "./";
import { LayoutContext } from "../layout";
import { isAuthenticate } from "../auth/fetchApi";
import "./style.css";

const Menu = () => {
  const { data, dispatch } = useContext(ProductDetailsContext);
  const { data: layoutData } = useContext(LayoutContext);

  const activeClass = "border-b-2 border-yellow-600 text-yellow-700 font-medium";
  const baseClass =
    "px-4 py-3 transition-all duration-300 cursor-pointer text-gray-500 hover:text-yellow-600";

  return (
    <div className="flex flex-col md:flex-row items-center justify-center border-b border-gray-200">
      <div
        onClick={() => dispatch({ type: "menu", payload: true })}
        className={`${baseClass} ${data.menu ? activeClass : ""}`}>
        Descrição
      </div>
      <div
        onClick={() => dispatch({ type: "menu", payload: false })}
        className={`${baseClass} ${!data.menu ? activeClass : ""} relative flex items-center`}>
        <span>Avaliações</span>
        <span className="ml-2 text-xs bg-yellow-600 text-white rounded-full px-2 py-0.5 shadow-sm">
          {layoutData.singleProductDetail.pRatingsReviews.length}
        </span>
      </div>
    </div>
  );
};

const RatingReview = () => (
  <Fragment>
    <AllReviews />
    {isAuthenticate() ? (
      <ReviewForm />
    ) : (
      <div className="mb-12 md:mx-16 lg:mx-20 xl:mx-24 bg-red-100 text-red-700 px-4 py-3 rounded-lg border border-red-300 text-sm">
        Você precisa fazer login para deixar uma avaliação.
      </div>
    )}
  </Fragment>
);

const ProductDetailsSectionTwo = () => {
  const { data } = useContext(ProductDetailsContext);
  const { data: layoutData } = useContext(LayoutContext);
  const [singleProduct, setSingleproduct] = useState({});

  useEffect(() => {
    setSingleproduct(layoutData.singleProductDetail || {});
  }, [layoutData.singleProductDetail]);

  return (
    <Fragment>
      <section className="m-4 md:mx-12 md:my-10">
        <Menu />
        {data.menu ? (
          <div
            className="my-6 text-gray-700 leading-relaxed text-sm md:text-base font-light"
            dangerouslySetInnerHTML={{
              __html: singleProduct.pDescription || "<p>Produto sem descrição.</p>",
            }}
          />
        ) : (
          <RatingReview />
        )}
      </section>

      <div className="m-4 md:mx-12 my-8 flex justify-center border-t border-b border-gray-200 bg-white text-gray-800 text-sm tracking-wide py-4">
        <div className="flex items-center space-x-2">
          <span className="text-gray-500">Categoria:</span>
          <span className="text-gray-700 font-medium">
            {singleProduct.pCategory?.cName || ""}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductDetailsSectionTwo;